import { useQuery } from '@tanstack/react-query';

import { SpecialGradeLevel } from '@suntex.fim/enums';
import { useFramework } from '@suntex.fim/framework';

// --- Query Keys ---

export const assessmentSummaryKeys = {
  all: ['assessmentSummary'] as const,
  team: (entityId: number) =>
    [...assessmentSummaryKeys.all, 'team', entityId] as const,
  school: (entityId: number, year: string, grade: SpecialGradeLevel) =>
    [...assessmentSummaryKeys.all, 'school', entityId, year, grade] as const,
};

// --- Queries ---

export function useAssessmentTeamSummaryQuery(
  entityId: number | undefined,
  options?: { enabled?: boolean },
) {
  const { api } = useFramework();
  return useQuery({
    queryKey: assessmentSummaryKeys.team(entityId!),
    queryFn: async () => {
      const response = await api.get_Assessment_SummaryTeam({
        entityId: entityId!,
      });
      return response.playerSummaries;
    },
    enabled: entityId != null && options?.enabled !== false,
  });
}

export function useAssessmentSchoolSummaryQuery(
  entityId: number | undefined,
  year: string | undefined,
  grade: SpecialGradeLevel | undefined,
  options?: { enabled?: boolean },
) {
  const { api } = useFramework();
  return useQuery({
    queryKey: assessmentSummaryKeys.school(entityId!, year!, grade!),
    queryFn: async () => {
      const response = await api.get_Assessment_SummarySchool({
        entityId: entityId!,
        year: year!,
        grade,
      });
      return response.schoolSummary;
    },
    enabled:
      entityId != null &&
      year != null &&
      grade != null &&
      options?.enabled !== false,
  });
}
